module.exports = __webpack_public_path__ + "static/img/tem.2a6abc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/tem.jpg
// module id = BBjP
// module chunks = 0